import React, { useEffect, useState } from "react";
import { Drawer, Tabs } from "antd";
import { ReactComponent as ResourcePlanIcon } from "../../../../../Images/ci/plan.svg";
import { ReactComponent as CostAnalysisIcon } from "../../../../../Images/ci/cost.svg";
import { ReactComponent as PolicyScaningIcon } from "../../../../../Images/ci/policy.svg";
import ResourcePlan from "./resourcePlan";
import PolicyScaning from "./policyScaning";

import { formatAwsStringWithUnderscore, renderEllipsis } from "../../../../../utils/formatting";
import { CiEvents } from "../../../../../utils/amplitudeEvents";
import { sendEvent } from "../../../../../utils/amplitude";
import CostAnalysis from "./costAnalysis";

import "./postPlanConfig.scss";

const { TabPane } = Tabs;
const TABS = {
  plan : {
    title: "Resource Plan",
    key: "plan",
    icon: <ResourcePlanIcon />,
    eventName: CiEvents.ciRunResourcePlanTabClick,
    getIsDisabled: () => false,
  },
  cost: {
    title: "Cost Analysis",
    key: "cost",
    icon: <CostAnalysisIcon />,
    eventName: CiEvents.ciRunResourceCostTabClick,
    getIsDisabled: (data) => !data?.isCostResults
  },
  policy: {
    title: "Policy Violations",
    key: "policy",
    icon: <PolicyScaningIcon />,
    eventName: CiEvents.ciRunResourcePolicyTabClick,
    getIsDisabled: (data) => !data?.scanResults?.length
  }
}

const PostPlanConfigHeader = ({ selectedTab, onSelectTab, title = "", subtitle = "", data }) => {
  const renderTabContent = (tab = {}) => {
    const { title: tabTitle = '', icon } = tab;
    return ( 
      <span className="PostPlanConfig__header-tab row">
        {<div className="PostPlanConfig__header-tab-icon">{icon}</div>}
        {tabTitle}
      </span>
  )}
  return (
      <div className="PostPlanConfig__header">
        <span className="title PostPlanConfig__header-title">
          {title}
        </span>
        <span className="sub-title PostPlanConfig__header-title sub">
          {subtitle}
        </span>
        <Tabs
          defaultActiveKey={TABS.plan.key}
          onChange={onSelectTab}
          activeKey={selectedTab}
          tabBarStyle={{ padding: 0 }}
        >
          {Object.keys(TABS).map((key) => (
            <TabPane tab={renderTabContent(TABS[key])} key={TABS[key].key} disabled={TABS[key].getIsDisabled(data)} />
          ))}
        </Tabs>
    </div>)
}

const AFTER_ACTIONS = ["create", "createdelete", "no-op", "import"];

const PostPlanConfig = ({ visible, onClose, data = {}, defaultTab = ""}) => {
  const [selectedTab, setSelectedTab] = useState(TABS.plan.key);
  const { before = [], after = [], diffs = [], action = "", scanResults = [], type: assetType, resourceId } = data;

  const code = AFTER_ACTIONS.includes(action) ? after : (action === "delete" ? before : diffs);

  useEffect(() => {
    return () => setSelectedTab(TABS.plan.key);
  }, [])

  useEffect(() => {
    if (defaultTab) {
      setSelectedTab(defaultTab);
    }
  },[defaultTab])

  const onCloseDrawer = () => {
    onClose();
    setSelectedTab(TABS.plan.key);
  };

  const renderByActiveTab = () => {
    switch (selectedTab) {
      case TABS.plan.key:
        return <ResourcePlan item={code} action={action} />;
      case TABS.cost.key:
        return <CostAnalysis data={data}/>
      case TABS.policy.key:
        return <PolicyScaning scanResults={scanResults}/>
      default:
        return null;
    }
  }

  const onChangeTab = (tab) => {
    const chosenTab = TABS[tab] || {};
    sendEvent(chosenTab.eventName, {});
    setSelectedTab(chosenTab.key);
  }

  return (
    <Drawer
      title={<PostPlanConfigHeader title={formatAwsStringWithUnderscore(assetType)} subtitle={renderEllipsis(resourceId, 80)} selectedTab={selectedTab} onSelectTab={onChangeTab} data={data}/>}
      placement="right"
      onClose={onCloseDrawer}
      visible={visible}
      getContainer={false}
      style={{ position: "absolute" }}
      className="PostPlanConfig"
      width="75%"
    >
      {renderByActiveTab()}
    </Drawer>
  );
};

export default PostPlanConfig;
